export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  netenttab: {
    asgardianstones: {
      redirectUrl: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "./images/slots/asgardianstones.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      redirectUrl: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "./images/slots/secrets-of-atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      redirectUrl: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "./images/slots/Steam-Tower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      redirectUrl: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "./images/slots/divine_fortune_megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      redirectUrl: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "./images/slots/Fruit_Shop_Megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      redirectUrl: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "./images/slots/Gorilla_Kingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      redirectUrl: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "./images/slots/Aloha-Christmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      redirectUrl: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "./images/slots/Aloha-Cluster-Pays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "./images/slots/Wild-Wild-West-The-Great-Train-Heist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      redirectUrl: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "./images/slots/Twin_Spin_Megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      redirectUrl: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "./images/slots/Turn_Your_Fortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "./images/slots/Pyramid-Quest-for-Immortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
    PiggyRiches: {
      redirectUrl: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      imgUrl: "./images/slots/Piggy-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches",
      providerName: "slots",
    },
    DarkKing: {
      redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "./images/slots/Dark-King-Forbidden-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    JingleSpin: {
      redirectUrl: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "./images/slots/Jingle-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      redirectUrl: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "./images/slots/Jack-Hammer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
    DeadorAlive: {
      redirectUrl: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive",
      providerName: "slots",
    },
    DeadorAlive2: {
      redirectUrl: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive-2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive 2",
      providerName: "slots",
    },
    JackandtheBeanstalk: {
      redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      imgUrl: "./images/slots/Jack-and-the-Beanstalk.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack and the Beanstalk",
      providerName: "slots",
    },
    Elements: {
      redirectUrl: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      imgUrl: "./images/slots/Elements-The-Awakening.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Elements: The Awakening",
      providerName: "slots",
    },
    FinnandtheSwirlySpin: {
      redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Finn and the Swirly Spin",
      providerName: "slots",
    },
    FruitShop: {
      redirectUrl: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      imgUrl: "./images/slots/Fruit-Shop.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop",
      providerName: "slots",
    },
    // DeadorAlive2FeatureBuy: {
    //   redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
    //   code: "1100100",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/DeadOrAlive2FeatureBuy.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Dead or Alive 2 Feature Buy",
    //   providerName: "slots",
    // },
  },

  // redtigertab: {
  //   NinjaWays: {
  //     redirectUrl: "/casino/ezgrt-ninja-ways",
  //     code: "1100166",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Ninja-Ways.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Ninja Ways",
  //     providerName: "slots",
  //   },
  //   PathofDestiny: {
  //     redirectUrl: "/casino/ezgrt-path-of-destiny",
  //     code: "1100167",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Path-of-Destiny.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Path of Destiny",
  //     providerName: "slots",
  //   },
  //   PersianFortune: {
  //     redirectUrl: "/casino/ezgrt-persian-fortune",
  //     code: "1100168",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Persian-Fortune.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Persian Fortune",
  //     providerName: "slots",
  //   },
  //   ReelHeist: {
  //     redirectUrl: "/casino/ezgrt-reel-heist",
  //     code: "1100169",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel-Heist.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel Heist",
  //     providerName: "slots",
  //   },
  //   ReelKingMegaways: {
  //     redirectUrl: "/casino/ezgrt-reel-king-mega",
  //     code: "1100052",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel_King_Mega.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel King Mega",
  //     providerName: "slots",
  //   },
  //   RobinHoodWildForest: {
  //     redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
  //     code: "1100170",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Robin Hood`s Wild Forest",
  //     providerName: "slots",
  //   },
  //   SnowWild: {
  //     redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
  //     code: "1100171",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Snow Wild And The 7 Features",
  //     providerName: "slots",
  //   },
  //   SylvanSpirits: {
  //     redirectUrl: "/casino/ezgrt-sylvan-spirits",
  //     code: "1100172",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Sylvan-Spirits.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Sylvan Spirits",
  //     providerName: "slots",
  //   },
  //   TheGreatestTrainRobbery: {
  //     redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
  //     code: "1100173",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Greatest-Train-Robbery.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Greatest Train Robbery",
  //     providerName: "slots",
  //   },
  //   TheWildHatter: {
  //     redirectUrl: "/casino/ezgrt-the-wild-hatter",
  //     code: "1100174",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Wild-Hatter.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Wild Hatter",
  //     providerName: "slots",
  //   },
  //   ThorLightning: {
  //     redirectUrl: "/casino/ezgrt-thors-lightning",
  //     code: "1100175",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Thor`s-Lightning.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Thor`s Lightning",
  //     providerName: "slots",
  //   },
  //   DragonLuck: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck",
  //     code: "1100001",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck",
  //     providerName: "slots",
  //   },
  //   DragonLuckReel: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
  //     code: "1100002",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck-Power-Reels.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck Power Reels",
  //     providerName: "slots",
  //   },
  // },

  redtigertab: {
    DragonsLuck: {
      redirectUrl: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuck.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck",
      providerName: "slots",
    },
    DragonsLuckPowerReels: {
      redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Power Reels",
      providerName: "slots",
    },
    Nights10001: {
      redirectUrl: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/10001Nights.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "10,001 Nights",
      providerName: "slots",
    },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    PiratesPlentyBattleforGold: {
      redirectUrl: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty Battle for Gold",
      providerName: "slots",
    },
    ChineseTreasures: {
      redirectUrl: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ChineseTreasures.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    FortuneHouse: {
      redirectUrl: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FortuneHouse.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune House",
      providerName: "slots",
    },
    DragonsFire: {
      redirectUrl: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFire.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire",
      providerName: "slots",
    },
    MagicGate: {
      redirectUrl: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MagicGate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Magic Gate",
      providerName: "slots",
    },
    LuckyFortuneCat: {
      redirectUrl: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyFortuneCat.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Fortune Cat",
      providerName: "slots",
    },
    DragonsLuckDeluxe: {
      redirectUrl: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Deluxe",
      providerName: "slots",
    },
    EpicJourney: {
      redirectUrl: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/EpicJourney.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Epic Journey",
      providerName: "slots",
    },
    PhoenixFirePowerReels: {
      redirectUrl: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Phoenix Fire Power Reels",
      providerName: "slots",
    },
    GoldenTemple: {
      redirectUrl: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTemple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Temple",
      providerName: "slots",
    },
    PiratesPlenty: {
      redirectUrl: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlenty.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty",
      providerName: "slots",
    },
    GoldenOffer: {
      redirectUrl: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenOffer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Offer",
      providerName: "slots",
    },
    RAsLegend: {
      redirectUrl: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RAsLegend.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "RA's Legend",
      providerName: "slots",
    },
    GonzosQuestMegaways: {
      redirectUrl: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GonzosQuestMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gonzo's Quest Megaways",
      providerName: "slots",
    },
    RainbowJackpots: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpots.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots",
      providerName: "slots",
    },
    MegaPyramid: {
      redirectUrl: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaPyramid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Pyramid",
      providerName: "slots",
    },
    WarOfGods: {
      redirectUrl: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WarOfGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "War Of Gods",
      providerName: "slots",
    },
    Strike777: {
      redirectUrl: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/777Strike.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "777 Strike",
      providerName: "slots",
    },
    AncientsBlessing: {
      redirectUrl: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AncientsBlessing.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ancients Blessing",
      providerName: "slots",
    },
    AurumCodex: {
      redirectUrl: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AurumCodex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aurum Codex",
      providerName: "slots",
    },
    BettyBorisandBoo: {
      redirectUrl: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BettyBorisandBoo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Betty, Boris and Boo",
      providerName: "slots",
    },
    // ZeusLightningPowerReels: {
    //   redirectUrl: "/casino/ezgrt-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/new/redtiger/ZeusLightningPower-Reels.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Zeus Lightning Power Reels",
    //   providerName: "slots",
    // },
    WingsofRa: {
      redirectUrl: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WingsofRa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wings of Ra",
      providerName: "slots",
    },
    TreasureMine: {
      redirectUrl: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TreasureMine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Treasure Mine",
      providerName: "slots",
    },
    ThorsVengeance: {
      redirectUrl: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsVengeance.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor's Vengeance",
      providerName: "slots",
    },
    RegalStreak: {
      redirectUrl: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalStreak.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Streak",
      providerName: "slots",
    },
    RegalBeasts: {
      redirectUrl: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Beasts",
      providerName: "slots",
    },
    ReelKingMega: {
      redirectUrl: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKingMega.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel King Mega",
      providerName: "slots",
    },
    ReelKeeper: {
      redirectUrl: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKeeper.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Keeper",
      providerName: "slots",
    },
    RainbowJackpotsPowerLines: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots Power Lines",
      providerName: "slots",
    },
    MysteryReels: {
      redirectUrl: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels",
      providerName: "slots",
    },
    PiggyRichesMegaways: {
      redirectUrl: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiggyRichesMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches Megaways",
      providerName: "slots",
    },
    JingleBells: {
      redirectUrl: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBells.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells",
      providerName: "slots",
    },
    JackinaPot: {
      redirectUrl: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JackinaPot.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack in a Pot",
      providerName: "slots",
    },
    FiveStar: {
      redirectUrl: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Star",
      providerName: "slots",
    },
    BountyRaid: {
      redirectUrl: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BountyRaid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bounty Raid",
      providerName: "slots",
    },
    CashUltimate: {
      redirectUrl: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashUltimate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Ultimate",
      providerName: "slots",
    },
    CashVolt: {
      redirectUrl: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashVolt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Volt",
      providerName: "slots",
    },
    DynamiteRiches: {
      redirectUrl: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DynamiteRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dynamite Riches",
      providerName: "slots",
    },
    DiamondBlitz: {
      redirectUrl: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiamondBlitz.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamond Blitz",
      providerName: "slots",
    },
    DragonsFireMegaways: {
      redirectUrl: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFireMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire Megaways",
      providerName: "slots",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/4Squad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "4 Squad",
      providerName: "slots",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AgentRoyale.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Agent Royale",
      providerName: "slots",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/5Families.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Families",
      providerName: "slots",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ArcadeBomb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Arcade Bomb",
      providerName: "slots",
    },
    CinderellasBall: {
      redirectUrl: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CinderellasBall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cinderella`s Ball",
      providerName: "slots",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Atlantis",
      providerName: "slots",
    },
    AztecSpins: {
      redirectUrl: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AztecSpins.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aztec Spins",
      providerName: "slots",
    },
    ClashoftheBeasts: {
      redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ClashoftheBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Clash of the Beasts",
      providerName: "slots",
    },
    CirquedelaFortune: {
      redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CirquedelaFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cirque de la Fortune",
      providerName: "slots",
    },
    CrazyGenie: {
      redirectUrl: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrazyGenie.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crazy Genie",
      providerName: "slots",
    },
    CrystalMirror: {
      redirectUrl: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrystalMirror.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crystal Mirror",
      providerName: "slots",
    },
    DevilsNumber: {
      redirectUrl: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DevilsNumber.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Devil`s Number",
      providerName: "slots",
    },
    DaVincisMystery: {
      redirectUrl: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DaVincisMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Da Vinci`s Mystery",
      providerName: "slots",
    },
    DiceDiceDice: {
      redirectUrl: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiceDiceDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice Dice Dice",
      providerName: "slots",
    },
    FiveStarsPowerReels: {
      redirectUrl: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStarsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Stars Power Reels",
      providerName: "slots",
    },
    GemsGoneWild: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWild.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild",
      providerName: "slots",
    },
    GemsGoneWildPowerReels: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild Power Reels",
      providerName: "slots",
    },
    GoldenCryptex: {
      redirectUrl: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenCryptex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Cryptex",
      providerName: "slots",
    },
    GoldenLeprechaunMegaways: {
      redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Leprechaun Megaways",
      providerName: "slots",
    },
    GrandWheel: {
      redirectUrl: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GrandWheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Grand Wheel",
      providerName: "slots",
    },
    GoldenTsar: {
      redirectUrl: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTsar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Tsar",
      providerName: "slots",
    },
    HoardofPoseidon: {
      redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/HoardofPoseidon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hoard of Poseidon",
      providerName: "slots",
    },
    JewelScarabs: {
      redirectUrl: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JewelScarabs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jewel Scarabs",
      providerName: "slots",
    },
    LegendofAthena: {
      redirectUrl: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LegendofAthena.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Legend of Athena",
      providerName: "slots",
    },
    JingleBellsPowerReels: {
      redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBellsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells Power Reels",
      providerName: "slots",
    },
    LuckyHalloween: {
      redirectUrl: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyHalloween.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Halloween",
      providerName: "slots",
    },
    LuckyLittleDevil: {
      redirectUrl: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyLittleDevil.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Little Devil",
      providerName: "slots",
    },
    LuckyValentine: {
      redirectUrl: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyValentine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Valentine",
      providerName: "slots",
    },
    LuckyWizard: {
      redirectUrl: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyWizard.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Wizard",
      providerName: "slots",
    },
    Masquerade: {
      redirectUrl: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Masquerade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Masquerade",
      providerName: "slots",
    },
    MayanGods: {
      redirectUrl: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MayanGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mayan Gods",
      providerName: "slots",
    },
    MegaDragon: {
      redirectUrl: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaDragon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Dragon",
      providerName: "slots",
    },
    MegaJade: {
      redirectUrl: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaJade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Jade",
      providerName: "slots",
    },
    MegaRise: {
      redirectUrl: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaRise.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Rise",
      providerName: "slots",
    },
    MultiplierRiches: {
      redirectUrl: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MultiplierRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Multiplier Riches",
      providerName: "slots",
    },
    MysteryReelsMegaways: {
      redirectUrl: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReelsMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels Megaways",
      providerName: "slots",
    },
    NinjaWays: {
      redirectUrl: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ninja Ways",
      providerName: "slots",
    },
    PathofDestiny: {
      redirectUrl: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PathofDestiny.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Path of Destiny",
      providerName: "slots",
    },
    PersianFortune: {
      redirectUrl: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PersianFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Persian Fortune",
      providerName: "slots",
    },
    ReelHeist: {
      redirectUrl: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      redirectUrl: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SylvanSpirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      redirectUrl: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheWildHatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      redirectUrl: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      redirectUrl: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TikiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      redirectUrl: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultCracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      redirectUrl: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TotemLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      redirectUrl: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WellofWishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      redirectUrl: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultofAnubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      redirectUrl: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      redirectUrl: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      redirectUrl: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/YucatansMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      redirectUrl: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      redirectUrl: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
  },

  ezugiSlots: {
    // Betwithstreamers: {
    //   name: "Bet with Streamers",
    //   redirectUrl: "/casino/ezg-bet-with-streamers",
    //   code: "mines",
    //   casino: "ezugi",
    //   provider: "ezugi",
    //   homeUrl: "",
    //   providerName: "Ezugi",
    //   imgUrl: "./images/trending/Betwithstreamers.webp",
    //   alt: "",
    // },
    ezmarbleracemonaco: {
      name: "EZ Marble Race Monaco",
      redirectUrl: "/casino/aggapezugi-ez-marble-race-monaco",
      code: "mines",
      casino: "ezugi",
      provider: "ezugi",
      homeUrl: "",
      providerName: "Ezugi",
      imgUrl: "./images/trending/ezmarbleracemonaco.webp",
      alt: "",
    },
  },

  // jiliGames: {
  //   Coin3Treasures: {
  //     redirectUrl: "/casino/qtechjili-3-coin-treasures",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-coin-treasures.webp",
  //     alt: "3 coin treasures",
  //     name: "3 coin treasures",
  //     providerName: "Jili",
  //   },
  //   Lucky3Piggy: {
  //     redirectUrl: "/casino/qtechjili-3-lucky-piggy",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-lucky-piggy.webp",
  //     alt: "3 lucky piggy",
  //     name: "3 lucky piggy",
  //     providerName: "Jili",
  //   },
  //   Pot3Dragons: {
  //     redirectUrl: "/casino/qtechjili-3-pot-dragons",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-pot-dragons.webp",
  //     alt: "3 pot dragons",
  //     name: "3 pot dragons",
  //     providerName: "Jili",
  //   },
  //   AgentAce: {
  //     redirectUrl: "/casino/qtechjili-agent-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/agent-ace.webp",
  //     alt: "agent ace",
  //     name: "agent ace",
  //     providerName: "Jili",
  //   },
  //   AliBaba: {
  //     redirectUrl: "/casino/qtechjili-ali-baba",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/ali-baba.webp",
  //     alt: "ali baba",
  //     name: "ali baba",
  //     providerName: "Jili",
  //   },
  //   ArenaFighter: {
  //     redirectUrl: "/casino/qtechjili-arena-fighter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/arena-fighter.webp",
  //     alt: "arena fighter",
  //     name: "arena fighter",
  //     providerName: "Jili",
  //   },
  //   AztecPriestess: {
  //     redirectUrl: "/casino/qtechjili-aztec-priestess",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/aztec-priestess.webp",
  //     alt: "aztec priestess",
  //     name: "aztec priestess",
  //     providerName: "Jili",
  //   },
  //   BanglaBeauty: {
  //     redirectUrl: "/casino/qtechjili-bangla-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bangla-beauty.webp",
  //     alt: "bangla beauty",
  //     name: "bangla beauty",
  //     providerName: "Jili",
  //   },
  //   BaoBoonChin: {
  //     redirectUrl: "/casino/qtechjili-bao-boon-chin",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bao-boon-chin.webp",
  //     alt: "bao boon chin",
  //     name: "bao boon chin",
  //     providerName: "Jili",
  //   },
  //   BoneFortune: {
  //     redirectUrl: "/casino/qtechjili-bone-fortune",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bone-fortune.webp",
  //     alt: "bone-fortune",
  //     name: "bone-fortune",
  //     providerName: "Jili",
  //   },
  //   BonusHunter: {
  //     redirectUrl: "/casino/qtechjili-bonus-hunter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bonus-hunter.webp",
  //     alt: "bonus-hunter",
  //     name: "bonus-hunter",
  //     providerName: "Jili",
  //   },
  //   BookOfGold: {
  //     redirectUrl: "/casino/qtechjili-book-of-gold",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/book-of-gold.webp",
  //     alt: "book of gold",
  //     name: "book of gold",
  //     providerName: "Jili",
  //   },
  //   BoxingKing: {
  //     redirectUrl: "/casino/qtechjili-boxing-king",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/boxing-king.webp",
  //     alt: "boxing king",
  //     name: "boxing king",
  //     providerName: "Jili",
  //   },
  //   BubbleBeauty: {
  //     redirectUrl: "/casino/qtechjili-bubble-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bubble-beauty.webp",
  //     alt: "bubble beauty",
  //     name: "bubble beauty",
  //     providerName: "Jili",
  //   },
  //   CargeBuffalo: {
  //     redirectUrl: "/casino/qtechjili-charge-buffalo",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/charge-buffalo.webp",
  //     alt: "charge buffalo",
  //     name: "charge buffalo",
  //     providerName: "Jili",
  //   },
  //   ChargeBuffaloAscent: {
  //     redirectUrl: "/casino/qtechjili-charge-buffalo-ascent",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/charge-buffalo-ascent.webp",
  //     alt: "charge buffalo ascent",
  //     name: "charge buffalo ascent",
  //     providerName: "Jili",
  //   },
  //   Chinshihuang: {
  //     redirectUrl: "/casino/qtechjili-chin-shi-huang",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/chin-shi-huang.webp",
  //     alt: "",
  //     name: "Chin Shi Huang",
  //     providerName: "Jili",
  //   },
  //   CrazyFafafa: {
  //     redirectUrl: "/casino/qtechjili-crazy-fafafa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy-fafafa.webp",
  //     alt: "crazy fafafa",
  //     name: "crazy fafafa",
  //     providerName: "Jili",
  //   },
  //   CrazyHunter: {
  //     redirectUrl: "/casino/qtechjili-crazy-hunter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy-hunter.webp",
  //     alt: "crazy hunter",
  //     name: "crazy hunter",
  //     providerName: "Jili",
  //   },
  //   Crazy777: {
  //     redirectUrl: "/casino/qtechjili-crazy777",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy777.webp",
  //     alt: "",
  //     name: "Crazy777",
  //     providerName: "Jili",
  //   },
  //   CricketKing18: {
  //     redirectUrl: "/casino/qtechjili-cricket-king-18",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/cricket-king-18.webp",
  //     alt: "cricket king 18",
  //     name: "cricket king 18",
  //     providerName: "Jili",
  //   },
  //   CricketSah75: {
  //     redirectUrl: "/casino/qtechjili-cricket-sah-75",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/cricket-sah-75.webp",
  //     alt: "cricket sah 75",
  //     name: "cricket sah 75",
  //     providerName: "Jili",
  //   },
  //   Dabanggg: {
  //     redirectUrl: "/casino/qtechjili-dabanggg",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/dabanggg.webp",
  //     alt: "dabanggg",
  //     name: "dabanggg",
  //     providerName: "Jili",
  //   },
  //   DevilFire2: {
  //     redirectUrl: "/casino/qtechjili-devil-fire-2",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/devil-fire-2.webp",
  //     alt: "devil fire 2",
  //     name: "devil fire 2",
  //     providerName: "Jili",
  //   },
  //   DiamondParty: {
  //     redirectUrl: "/casino/qtechjili-diamond-party",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/diamond-party.webp",
  //     alt: "diamond party",
  //     name: "diamond party",
  //     providerName: "Jili",
  //   },
  //   DragonTreasure: {
  //     redirectUrl: "/casino/qtechjili-dragon-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/dragon-treasure.webp",
  //     alt: "dragon treasure",
  //     name: "dragon treasure",
  //     providerName: "Jili",
  //   },
  //   EgyptsGlow: {
  //     redirectUrl: "/casino/qtechjili-egypts-glow",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/egypts-glow.webp",
  //     alt: "egypt's glow",
  //     name: "egypt's glow",
  //     providerName: "Jili",
  //   },
  //   FaFaFa: {
  //     redirectUrl: "/casino/qtechjili-fa-fa-fa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fa-fa-fa.webp",
  //     alt: "fa fa fa",
  //     name: "fa fa fa",
  //     providerName: "Jili",
  //   },
  //   Fengshen: {
  //     redirectUrl: "/casino/qtechjili-fengshen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fengshen.webp",
  //     alt: "fengshen",
  //     name: "fengshen",
  //     providerName: "Jili",
  //   },
  //   FortuneGems: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems.webp",
  //     alt: "fortune gems",
  //     name: "fortune gems",
  //     providerName: "Jili",
  //   },
  //   FortuneGems2: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems-2",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems-2.webp",
  //     alt: "fortune gems 2",
  //     name: "fortune gems 2",
  //     providerName: "Jili",
  //   },
  //   FortuneGems3: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems-3",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems-3.webp",
  //     alt: "fortune gems 3",
  //     name: "fortune gems 3",
  //     providerName: "Jili",
  //   },
  //   FortuneMonkey: {
  //     redirectUrl: "/casino/qtechjili-fortune-monkey",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-monkey.webp",
  //     alt: "fortune monkey",
  //     name: "fortune monkey",
  //     providerName: "Jili",
  //   },
  //   FortuneTree: {
  //     redirectUrl: "/casino/qtechjili-fortune-tree",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-tree.webp",
  //     alt: "",
  //     name: "Fortune Tree",
  //     providerName: "Jili",
  //   },
  //   GemParty: {
  //     redirectUrl: "/casino/qtechjili-gem-party",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/gem-party.webp",
  //     alt: "",
  //     name: "Gem Party",
  //     providerName: "Jili",
  //   },
  //   GodOfMartial: {
  //     redirectUrl: "/casino/qtechjili-god-of-martial",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/god-of-martial.webp",
  //     alt: "",
  //     name: "God Of Martial",
  //     providerName: "Jili",
  //   },
  //   GoldRush: {
  //     redirectUrl: "/casino/qtechjili-gold-rush",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/gold-rush.webp",
  //     alt: "gold rush",
  //     name: "gold rush",
  //     providerName: "Jili",
  //   },
  //   GoldenBank: {
  //     redirectUrl: "/casino/qtechjili-golden-bank",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-bank.webp",
  //     alt: "golden bank",
  //     name: "golden bank",
  //     providerName: "Jili",
  //   },
  //   GoldenEmpire: {
  //     redirectUrl: "/casino/qtechjili-golden-empire",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-empire.webp",
  //     alt: "golden empire",
  //     name: "golden empire",
  //     providerName: "Jili",
  //   },
  //   GoldenJoker: {
  //     redirectUrl: "/casino/qtechjili-golden-joker",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-joker.webp",
  //     alt: "golden joker",
  //     name: "golden joker",
  //     providerName: "Jili",
  //   },
  //   GoldenQueen: {
  //     redirectUrl: "/casino/qtechjili-golden-queen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-queen.webp",
  //     alt: "golden queen",
  //     name: "golden queen",
  //     providerName: "Jili",
  //   },
  //   GoldenTemple: {
  //     redirectUrl: "/casino/qtechjili-golden-temple",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-temple.webp",
  //     alt: "golden temple",
  //     name: "golden temple",
  //     providerName: "Jili",
  //   },
  //   HappyTaxi: {
  //     redirectUrl: "/casino/qtechjili-happy-taxi",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/happy-taxi.webp",
  //     alt: "happy taxi",
  //     name: "happy taxi",
  //     providerName: "Jili",
  //   },
  //   HawaiiBeauty: {
  //     redirectUrl: "/casino/qtechjili-hawaii-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hawaii-beauty.webp",
  //     alt: "hawaii beauty",
  //     name: "hawaii beauty",
  //     providerName: "Jili",
  //   },
  //   HotChili: {
  //     redirectUrl: "/casino/qt-red-hot-chili-7s",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hot-chilli.webp",
  //     alt: "Hot Chilli",
  //     name: "Hot Chilli",
  //     providerName: "Jili",
  //   },
  //   HyperBrust: {
  //     redirectUrl: "/casino/qtechjili-hyper-burst",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hyper-burst.webp",
  //     alt: "Hyper Burst",
  //     name: "Hyper Burst",
  //     providerName: "Jili",
  //   },
  //   JiliCaishen: {
  //     redirectUrl: "/casino/qtechjili-jili-caishen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/jili-caishen.webp",
  //     alt: "jili caishen",
  //     name: "jili caishen",
  //     providerName: "Jili",
  //   },
  //   JungleKing: {
  //     redirectUrl: "/casino/qtechjili-jungle-king",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/jungle-king.webp",
  //     alt: "jungle king",
  //     name: "jungle king",
  //     providerName: "Jili",
  //   },
  //   KingArthur: {
  //     redirectUrl: "/casino/qtechjili-king-arthur",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/king-arthur.webp",
  //     alt: "king arthur",
  //     name: "king arthur",
  //     providerName: "Jili",
  //   },
  //   LegacyOfEgypt: {
  //     redirectUrl: "/casino/qtechjili-legacy-of-egypt",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/legacy-of-egypt.webp",
  //     alt: "legacy of egypt",
  //     name: "legacy of egypt",
  //     providerName: "Jili",
  //   },
  //   LuckyBall: {
  //     redirectUrl: "/casino/qtechjili-lucky-ball",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/lucky-ball.webp",
  //     alt: "lucky ball",
  //     name: "lucky ball",
  //     providerName: "Jili",
  //   },
  //   LuckyComing: {
  //     redirectUrl: "/casino/qtechjili-lucky-coming",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/lucky-coming.webp",
  //     alt: "lucky coming",
  //     name: "lucky coming",
  //     providerName: "Jili",
  //   },
  //   MagicLamp: {
  //     redirectUrl: "/casino/qtechjili-magic-lamp",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/magic-lamp.webp",
  //     alt: "magic lamp",
  //     name: "magic lamp",
  //     providerName: "Jili",
  //   },
  //   MasterTiger: {
  //     redirectUrl: "/casino/qtechjili-master-tiger",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/master-tiger.webp",
  //     alt: "master tiger",
  //     name: "master tiger",
  //     providerName: "Jili",
  //   },
  //   MayanEmpire: {
  //     redirectUrl: "/casino/qtechjili-mayan-empire",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/mayan-empire.webp",
  //     alt: "mayan -empire",
  //     name: "mayan -empire",
  //     providerName: "Jili",
  //   },
  //   Medusa: {
  //     redirectUrl: "/casino/qtechjili-medusa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/medusa.webp",
  //     alt: "medusa",
  //     name: "medusa",
  //     providerName: "Jili",
  //   },
  //   MegaAce: {
  //     redirectUrl: "/casino/qtechjili-mega-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/mega-ace.webp",
  //     alt: "mega ace",
  //     name: "mega ace",
  //     providerName: "Jili",
  //   },
  //   MoneyComing: {
  //     redirectUrl: "/casino/qtechjili-money-coming",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/money-coming.webp",
  //     alt: "money coming",
  //     name: "money coming",
  //     providerName: "Jili",
  //   },
  //   MoneyComingExpandedBets: {
  //     redirectUrl: "/casino/qtechjili-money-coming-expanded-bets",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/money-coming-expanded-bets.webp",
  //     alt: "money coming expanded bets",
  //     name: "money coming expanded bets",
  //     providerName: "Jili",
  //   },
  //   MonkeyParty: {
  //     redirectUrl: "/casino/qtechjili-monkey-party",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/monkey-party.webp",
  //     alt: "monkey party",
  //     name: "monkey party",
  //     providerName: "Jili",
  //   },
  //   NekoFortune: {
  //     redirectUrl: "/casino/qtechjili-neko-fortune",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/neko-fortune.webp",
  //     alt: "neko fortune",
  //     name: "neko fortune",
  //     providerName: "Jili",
  //   },
  //   NightCity: {
  //     redirectUrl: "/casino/qtechjili-night-city",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/night-city.webp",
  //     alt: "night city",
  //     name: "night city",
  //     providerName: "Jili",
  //   },
  //   PartyNight: {
  //     redirectUrl: "/casino/qtechjili-party-night",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/party-night.webp",
  //     alt: "party night",
  //     name: "party night",
  //     providerName: "Jili",
  //   },
  //   PartyStar: {
  //     redirectUrl: "/casino/qtechjili-party-star",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/party-star.webp",
  //     alt: "party star",
  //     name: "party star",
  //     providerName: "Jili",
  //   },
  //   PharaohTreasure: {
  //     redirectUrl: "/casino/qtechjili-pharaoh-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/pharaoh-treasure.webp",
  //     alt: "pharaoh treasure",
  //     name: "pharaoh treasure",
  //     providerName: "Jili",
  //   },
  //   PirateQueen: {
  //     redirectUrl: "/casino/qtechjili-pirate-queen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/pirate-queen.webp",
  //     alt: "pirate queen",
  //     name: "pirate queen",
  //     providerName: "Jili",
  //   },
  //   Poseidon: {
  //     redirectUrl: "/casino/qtechjili-poseidon",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/poseidon.webp",
  //     alt: "poseidon",
  //     name: "poseidon",
  //     providerName: "Jili",
  //   },
  //   PotionWizard: {
  //     redirectUrl: "/casino/qtechjili-potion-wizard",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/potion-wizard.webp",
  //     alt: "potion wizard",
  //     name: "potion wizard",
  //     providerName: "Jili",
  //   },
  //   RomaX: {
  //     redirectUrl: "/casino/qtechjili-roma-x",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/roma-x.webp",
  //     alt: "roma x",
  //     name: "roma x",
  //     providerName: "Jili",
  //   },
  //   Samba: {
  //     redirectUrl: "/casino/qtechjili-samba",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/samba.webp",
  //     alt: "samba",
  //     name: "samba",
  //     providerName: "Jili",
  //   },
  //   SecretTreasure: {
  //     redirectUrl: "/casino/qtechjili-secret-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/secret-treasure.webp",
  //     alt: "secret treasure",
  //     name: "secret treasure",
  //     providerName: "Jili",
  //   },
  //   ShanghaiBeauty: {
  //     redirectUrl: "/casino/qtechjili-shanghai-beauty",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/shanghai-beauty.webp",
  //     alt: "ShanghaiBeauty",
  //     name: "Shanghai Beauty",
  //     providerName: "Jili",
  //   },
  //   SinCity: {
  //     redirectUrl: "/casino/qtechjili-sin-city",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/sin-city.webp",
  //     alt: "sin city",
  //     name: "sin city",
  //     providerName: "Jili",
  //   },
  //   SuperAce: {
  //     redirectUrl: "/casino/qtechjili-super-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-ace.webp",
  //     alt: "super ace",
  //     name: "super ace",
  //     providerName: "Jili",
  //   },
  //   SuperAceDeluxe: {
  //     redirectUrl: "/casino/qtechjili-super-ace-deluxe",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-ace-deluxe.webp",
  //     alt: "super ace deluxe",
  //     name: "super ace deluxe",
  //     providerName: "Jili",
  //   },
  //   SuperRich: {
  //     redirectUrl: "/casino/qtechjili-super-rich",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-rich.webp",
  //     alt: "super rich",
  //     name: "super rich",
  //     providerName: "Jili",
  //   },
  //   SweetLand: {
  //     redirectUrl: "/casino/qtechjili-sweet-land",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/sweet-land.webp",
  //     alt: "sweet land",
  //     name: "sweet land",
  //     providerName: "Jili",
  //   },
  //   ThorX: {
  //     redirectUrl: "/casino/qtechjili-thor-x",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/thor-x.webp",
  //     alt: "thor x",
  //     name: "thor x",
  //     providerName: "Jili",
  //   },
  //   TrialOfPhoenix: {
  //     redirectUrl: "/casino/qtechjili-trial-of-phoenix",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/trial-of-phoenix.webp",
  //     alt: "trial of phoenix",
  //     name: "trial of phoenix",
  //     providerName: "Jili",
  //   },
  //   TwinWins: {
  //     redirectUrl: "/casino/qtechjili-twin-wins",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/twin-wins.webp",
  //     alt: "twin wins",
  //     name: "twin wins",
  //     providerName: "Jili",
  //   },
  //   WarOfDragons: {
  //     redirectUrl: "/casino/qtechjili-war-of-dragons",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/war-of-dragons.webp",
  //     alt: "war of dragons",
  //     name: "war of dragons",
  //     providerName: "Jili",
  //   },
  //   WildAce: {
  //     redirectUrl: "/casino/qtechjili-wild-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/wild-ace.webp",
  //     alt: "wild ace",
  //     name: "wild ace",
  //     providerName: "Jili",
  //   },
  //   WildRacer: {
  //     redirectUrl: "/casino/qtechjili-wild-racer",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/wild-racer.webp",
  //     alt: "wild racer",
  //     name: "wild racer",
  //     providerName: "Jili",
  //   },
  //   WitchesNight: {
  //     redirectUrl: "/casino/qtechjili-witches-night",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/witches-night.webp",
  //     alt: "witches' night",
  //     name: "witches' night",
  //     providerName: "Jili",
  //   },
  //   WorldCup: {
  //     redirectUrl: "/casino/qtechjili-world-cup",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/world-cup.webp",
  //     alt: "world cup",
  //     name: "world cup",
  //     providerName: "Jili",
  //   },
  //   Xiyangyang: {
  //     redirectUrl: "/casino/qtechjili-xiyangyang",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/xiyangyang.webp",
  //     alt: "xiyangyang",
  //     name: "xiyangyang",
  //     providerName: "Jili",
  //   },
  //   Zeus: {
  //     redirectUrl: "/casino/qtechjili-zeus",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/zeus.webp",
  //     alt: "zeus",
  //     name: "zeus",
  //     providerName: "Jili",
  //   },
  // },

  // jiliGaming: {
  //   PirateQueen: {
  //     code: "98567",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Pirate Queen",
  //     name: "Pirate Queen",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-pirate-queen",
  //   },
  //   WildRacer: {
  //     code: "56768",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Wild Racer",
  //     name: "Wild Racer",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-wild-racer",
  //   },
  //   NekoFortune: {
  //     code: "98790",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Neko Fortune",
  //     name: "Neko Fortune",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-neko-fortune",
  //   },
  //   Samba: {
  //     code: "98789",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Samba",
  //     name: "Samba",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-samba",
  //   },
  //   WorldCup: {
  //     code: "56968",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "World Cup",
  //     name: "World Cup",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-world-cup",
  //   },
  //   BonusHunter: {
  //     code: "67660",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Bonus Hunter",
  //     name: "Bonus Hunter",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
  //   },
  //   JILICAISHEN: {
  //     code: "67580",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "JILI CAISHEN",
  //     name: "JILI CAISHEN",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-jili-caishen",
  //   },
  //   MayanEmpire: {
  //     code: "67600",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Mayan Empire",
  //     name: "Mayan Empire",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/mayanempire.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-mayan-empire",
  //   },
  //   BoneFortune: {
  //     code: "87564",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Bone Fortune",
  //     name: "Bone Fortune",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bonefortune.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-bone-fortune",
  //   },
  //   GoldRush: {
  //     code: "67620",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Gold Rush",
  //     name: "Gold Rush",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/goldrush.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-gold-rush",
  //   },
  //   HappyTaxi: {
  //     code: "67567",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Happy Taxi",
  //     name: "Happy Taxi",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-happy-taxi",
  //   },
  //   ThorX: {
  //     code: "67570",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Thor X",
  //     name: "Thor X",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-thor-x",
  //   },
  //   BookofGold: {
  //     code: "56767",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Book of Gold",
  //     name: "Book of Gold",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-book-of-gold",
  //   },
  //   Medusa: {
  //     code: "98788",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Medusa",
  //     name: "Medusa",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-medusa",
  //   },
  //   GoGoalBingo: {
  //     code: "98791",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Go Goal Bingo",
  //     name: "Go Goal Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
  //   },
  //   ColorGame: {
  //     code: "67630",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Color Game",
  //     name: "Color Game",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-color-game",
  //   },
  //   JackpotBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Jackpot Bingo",
  //     name: "Jackpot Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
  //   },
  //   LuckyBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Bingo",
  //     name: "Lucky Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
  //   },
  //   WinDrop: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Win Drop",
  //     name: "Win Drop",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-win-drop",
  //   },
  //   FortuneBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Fortune Bingo",
  //     name: "Fortune Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
  //   },
  //   Baccarat: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Baccarat",
  //     name: "Baccarat",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-baccarat",
  //   },
  //   iRichBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "iRich Bingo",
  //     name: "iRich Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-irich-bingo",
  //   },
  //   DragonTiger: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Dragon & Tiger",
  //     name: "Dragon & Tiger",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
  //   },
  //   BigSmall: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Big Small",
  //     name: "Big Small",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Bigsmall.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-big-small",
  //   },
  //   GoldenJoker: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Golden Joker",
  //     name: "Golden Joker",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-golden-joker",
  //   },
  //   MasterTiger: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Master Tiger",
  //     name: "Master Tiger",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-master-tiger",
  //   },
  //   WildAce: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Wild Ace",
  //     name: "Wild Ace",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Wildace.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-wild-ace",
  //   },
  //   Crazy777: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Crazy 777",
  //     name: "Crazy 777",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-crazy777",
  //   },
  // },
};
